﻿<div class="route-component">
    <div class="search-component">
        <h4>
            PI/SPI Search
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button (click)="popiMappings()">
                        Configure POPI Mappings
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="!mappingsValid && !verifyingMappings" class="error-panel">
            <h5>POPI Setup Issues</h5>
            <ul>
                <li *ngFor="let error of mappingErrors">
                    {{ error }}
                </li>
            </ul>
        </div>

        <div *ngIf="!mappingsValid && verifyingMappings" class="warn-panel">
            <h5>
                <i class="fas fa-spinner fa-spin"></i>
                Verifying POPI Setup...
            </h5>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input  type="text" class="search-input" placeholder="POPI Reference ID" [(ngModel)]="popiRefId" [disabled]="!mappingsValid">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" [disabled]="!mappingsValid" (keydown.enter)="searchPopi()">

                    <button class="search-button" [disabled]="!mappingsValid" (click)="searchPopi()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="loader-wrapper" *ngIf="refreshInProgress">
            <div class="bar-loader"></div>
            <span class="loading-text">Loading...</span>
        </div>

        <div *ngIf="popiResults.length > 0">
            <div *ngFor="let result of popiResults">
                <h5>{{ result.entityDisplayName }}</h5>

                <pageable-table
                    [items]="result.records"
                    [columns]="getColumnsFor(result)"
                    [paging]="getPagingDataFor(result.records)"
                    (refreshData)="onRefreshPopi($event)"
                    [showDelete]="true"
                    (deleteItem)="deidentifyRecord(deidentifyWrap(result, $event))">
                </pageable-table>
            </div>
        </div>
    </div>
</div>
